'use client';

import { NavBarMain } from '@/components/seasons/NavBarMain';
import { Footer } from '@/components/seasons/Footer';

export default function NotFound() {
  return (
    <div className="bl-page">
      <NavBarMain ctaLabel="REQUEST A DEMO" ctaHref="https://innovaccer.com/request-a-demo" storiesHref="/blogs" />
        <main
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          padding: 'var(--seasons-space-16)',
        }}
      >
        <p
          className="type-display-2xl"
          style={{ color: 'var(--seasons-color-cyber-blue)', margin: 0, lineHeight: 1 }}
        >
          404
        </p>
        <h1
          className="type-display-md"
          style={{ color: 'var(--seasons-color-prose-heading)', marginTop: 'var(--seasons-space-4)', marginBottom: 0 }}
        >
          Page not found
        </h1>
        <p
          className="type-body-lg"
          style={{
            color: 'var(--seasons-color-text-secondary)',
            marginTop: 'var(--seasons-space-4)',
            maxWidth: '480px',
          }}
        >
          The page you're looking for doesn't exist or has been moved.
        </p>
        <a href="https://innovaccer.com" className="block-button-link" style={{ marginTop: 'var(--seasons-space-8)', alignSelf: 'center' }}>
          <div className="block-button block-button--md block-button--midnight">
            <div className="block-button__text">
              <span className="btn-primary-text">Back to home</span>
              <span className="btn-hover-text">Back to home</span>
            </div>
          </div>
        </a>
      </main>

      <Footer theme="light" />
    </div>
  );
}
